export const ACCESS_TOKEN = "INTREX_ACCESS_TOKEN"
export const INTREX_AUTH = "INTREX_AUTH"
export const TOKEN_CSRF = "INTREX_CSRF_TOKEN"